import { atom, selector } from "recoil";
import { INSURANCE_PRODUCTS } from "constants";

export const selectedInsuranceProductIndices = atom({
  key: "selectedInsuranceProductIndices",
  default: [],
});

export const completedInsuranceProductSetup = atom({
  key: "completedInsuranceProductSetup",
  default: [],
});

export const completedDocumentUpload = atom ({
  key:"completedDocumentUpload",
  default: []
})

export const selectedInsuranceProducts = selector({
  key: "selectedInsuranceProducts",
  get: ({ get }) => {
    const indices = get(selectedInsuranceProductIndices);

    return indices.map((index) => INSURANCE_PRODUCTS[index]);
  },
});
